/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Not_FoundInputs */

const da_common_not_found = /** @type {(inputs: Common_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siden findes ikke.`)
};

/** @type {(inputs: Common_Not_FoundInputs) => LocalizedString} */
const en_common_not_found = da_common_not_found;

/**

* @param {Common_Not_FoundInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_not_found = /** @type {((inputs?: Common_Not_FoundInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Not_FoundInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_not_found(inputs)
	return /** @type {LocalizedString} */ ("Siden findes ikke.")
});